import Component from 'Component';
import AutoTranslate from './city/AutoTranslate';
import Airport from './city/Airport';
import Location from './city/Location';

export default class City extends Component {

  _namespace = this.constructor.name;

  _components = [
    new AutoTranslate(this.App, this._namespace),
    new Airport(this.App, this._namespace),
    new Location(this.App, this._namespace),
  ];

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return super.configure();
  }

  get components() {
    return this._components;
  }

  initialize() {
    return super.initialize();
  }

}